import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nostriservizi',
  templateUrl: './nostriservizi.component.html',
  styleUrls: ['./nostriservizi.component.scss']
})
export class NostriserviziComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/nostriservizi/nostriservizi.component.ts